import React, { useEffect, useState } from 'react';
import { BrowserRouter , Route, Routes, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { onSignIn, onSignOut } from './utils/AuthFunctionUtils';

import './styles/App.scss';
import AccessDenied from './components/AccessDenied';
import PayloadEstimates from './components/PayloadEstimates';
import LoadingSpinner from './components/LoadingSpinner';


const App: React.FC = () => {
  return (
    <div className="app-container">
     <AuthProvider onSignIn={onSignIn} onSignOut={onSignOut}>
    
            <AppRoutes />
      
    </AuthProvider> 
    </div>
  );
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated, isLoading, userData } = useAuth();
 useEffect(() => {
    if (!isLoading && userData) {
     
      const currentUrl = window.location.href;

      const baseUrl = currentUrl.split("/Callback")[0];
      window.history.replaceState({}, document.title, baseUrl);
    }
  }, [isAuthenticated, isLoading, userData]); 


  if (isLoading) {
    return <LoadingSpinner size="large" />;
  }

  return (
   


<BrowserRouter>
<Routes>

<Route path="/payloadestimates" element= {<PayloadEstimates />} />
<Route path="/payloadestimates/Callback" element= {<PayloadEstimates />} />
<Route path="*" element={<Navigate to="/payloadestimates" replace />} />
{/* <Route path="/access-denied" element={<AccessDenied />} /> */}
  {/* <Route path="*" element={isAuthenticated ? <Navigate to="/payloadestimates" replace /> : <Navigate to="/" replace />} /> */}
</Routes>
</BrowserRouter>
  );
};

export default App;


{/* <Routes>
<Route path="/" element={<Navigate to="/payloadestimates/callback" replace />} />
<Route path="/payloadestimates/callback" element={isAuthenticated ? <PayloadEstimates  /> : <Navigate to="/" replace />} />
<Route path="/payloadestimates/overview" element={isAuthenticated ? <PayloadEstimates /> : <Navigate to="/" replace />} />
<Route path="/access-denied" element={<AccessDenied />} />

<Route path="*" element={isAuthenticated ? <Navigate to="/payloadestimates/overview" replace /> : <Navigate to="/" replace />} />
</Routes> */}